import { useEffect, useState } from "react";
import axios from "axios";
import { Package } from "lucide-react";
import { API } from "@/components/JournalParts";

const daysSince = (iso) => Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 86400000));

export const ShipCount = ({ token, refreshKey, onClick }) => {
  const [s, setS] = useState(null);
  useEffect(() => {
    axios.get(`${API}/keeper/orders/summary`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setS(r.data)).catch(() => {});
  }, [token, refreshKey]);
  if (!s) return null;
  if (!s.to_ship) {
    return <p data-testid="ship-count" className="text-[12px] text-[#8FB08A]/80 font-display italic">The workshop is clear. Nothing waiting to ship.</p>;
  }
  const days = s.oldest_paid_at ? daysSince(s.oldest_paid_at) : 0;
  const late = days > 3;
  return (
    <button data-testid="ship-count" onClick={onClick}
      className="group inline-flex items-center gap-3 px-4 py-2.5 border border-[#B5A642]/40 rounded-sm hover:border-[#B5A642] transition-colors">
      <Package className="w-4 h-4 text-[#B5A642]" strokeWidth={1.5} />
      <span className="font-display text-xl text-[#E8DDC7]" data-testid="ship-count-number">{s.to_ship}</span>
      <span className="text-[11px] uppercase tracking-[0.2em] text-[#D3CEC4]/60">to ship</span>
      <span className="text-[#D3CEC4]/30">·</span>
      <span data-testid="ship-count-oldest" className={`text-[12px] ${late ? "text-[#E07A5F] font-semibold" : "text-[#D3CEC4]/60"}`}>
        oldest waiting {days === 0 ? "less than a day" : `${days} day${days === 1 ? "" : "s"}`}
      </span>
    </button>
  );
};
